import { ViewPreset, DateHelper } from "@bryntum/schedulerpro";
import Vue from "vue";

// 日単位プリセット
const viewPresetDay = new ViewPreset({
  id: "day",
  name: "日単位",
  tickWidth: 42,
  tickHeight: 50,
  shiftUnit: "day",
  defaultSpan: 52,
  timeResolution: { unit: "day", increment: 1 },
  headers: [
    {
      unit: "month",
      dateFormat: date => `${date.getFullYear()}年${date.getMonth() + 1}月`,
    },
    {
      unit: "day",
      renderer: (start, end, headerConfig) => {
        const day = start.getDay();
        if (day === 0) headerConfig.headerCellCls = "calendar-sunday";
        if (day === 6) headerConfig.headerCellCls = "calendar-saturday";
        return DateHelper.format(start, "D日");
      },
    },
  ],
  columnLinesFor: 1,
});

// 週単位プリセット
const viewPresetWeek = new ViewPreset({
  id: "week",
  name: "週単位",
  tickWidth: 100,
  tickHeight: 50,
  shiftUnit: "week",
  defaultSpan: 52,
  timeResolution: { unit: "day", increment: 1 },
  headers: [
    {
      unit: "month",
      dateFormat: date => `${date.getFullYear()}年${date.getMonth() + 1}月`,
    },
    {
      unit: "week",
      renderer: date => `${date.getDate()}日`,
    },
  ],
  columnLinesFor: 1,
});

// 月単位プリセット
const viewPresetMonth = new ViewPreset({
  id: "month",
  name: "月単位",
  tickWidth: 100,
  tickHeight: 50,
  shiftUnit: "month",
  defaultSpan: 12,
  timeResolution: { unit: "month", increment: 1 },
  headers: [
    {
      unit: "year",
      dateFormat: date => `${date.getFullYear()}年`,
    },
    {
      unit: "month",
      dateFormat: date => `${date.getMonth() + 1}月`,
    },
  ],
  columnLinesFor: 1,
});

/**
 *
 * @param {Object} vc Vueコンポーネント
 * @returns
 */
const ViewPresetsHandler = vc => {
  const _vc = vc;

  const onScaleChange = async (startDate, endDate, presetId) => {
    const schedulerRef = _vc.$refs.scheduler;
    const scheduler = schedulerRef && schedulerRef.instance;

    let presets = [];
    if (_vc.schedulerConfig && Array.isArray(_vc.schedulerConfig.presets)) {
      presets = _vc.schedulerConfig.presets;
    }

    const presetExists = presets.some(function(preset) {
      return preset.id === presetId;
    });

    if (scheduler && presetExists) {
      scheduler.viewPreset = presetId;
      await _vc.$refs.scheduler.instance.setTimeSpan(startDate, endDate);
    } else {
      Vue.$log.warn(
        "スケジューラまたはプリセットが見つかりません",
        scheduler,
        presetId
      );
    }
  };

  return {
    onScaleChange,
  };
};

const defaultPresets = [viewPresetDay, viewPresetWeek, viewPresetMonth];

export { defaultPresets, ViewPresetsHandler };
